const api = 'https://microsites.forlagshuset.no/fhapi/v1/layout/path/462';

const fetchData = async lang => (await fetch(`${api}?lang=${lang}`)).json();

export default fetchData;
